import {
	CircularProgress,
	Tooltip,
	Typography,
	styled,
} from "@mui/material";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ModalConfirmButton from "../ModalMessages/ModalConfirmButton";
import { BUTTON_COLOR_NEW_UI } from "../../../../utils/ColorPicker";
import { appType } from "../../../../utils/config/configHelpers";
import { addAppNotification } from "../../../../state/actions/appNotifications";
import { showToast } from "../../toaster";
import { BANNER_TYPE_INFO } from "../../../../utils/constants";
import PasswordFieldForModals from "../ModalMessages/PasswordFieldForModals";
import { UserServiceClientApi} from "../../../../services/api/UserApiServices";
import webSocketApiService from "../../../../services/socket/wsApiServices";

const CustomErrorTypography = styled(Typography)(({ theme }) => ({
	fontSize: '14px',
	color: '#F74646',
	marginBottom: '30px',
	textAlign: 'center',
	marginTop: '-15px',
	marginRight: '15px',
	fontFamily:'Figtree-regular'
}));

const CustomToolTip = styled('div')({
	zIndex: 9999999,
	position: 'absolute',
	backgroundColor: '#fff',
	borderRadius: '6px',
	padding: '20px',
	top:'12px',
	boxShadow: '0 0 6px 0 rgba(42,45,60,0.4)',
});

const MatchStatusTypography = styled(Typography)(({ theme }) => ({
	fontSize: '14px',
	color: '#FFFFFF',
	fontFamily:'Figtree-regular',
	textAlign: 'center',
	borderRadius:'5px',
	backgroundColor:'#2fc76f',
	width:'80px',
	padding:'2px 4px',
	position:'relative',
	right:'-340px',
	borderTopLeftRadius:'0px',
	top:'1px',
	bottom:'-20px'
}));

const ChangePasswordModal = ({onClose}) => {
	const [currentPassword, setCurrentPassword] = useState("");
	const [password, setPassword] = useState("");
	const [password2, setPassword2] = useState("");
	const [error, setError] = useState(null);
	const [showToolTip, setShowToolTip] = useState(false);
	const [passwordCriteria, setPasswordCriteria] = useState([
		{ text: " One uppercase letter", isDone: false },
		{ text: " One lowercase letter", isDone: false },
		{ text: " One special character", isDone: false },
		{ text: " One number", isDone: false },
		{ text: " 8 characters minimum", isDone: false },
	]);
	const [showSpinner , setShowSpinner] = useState(false)

	const dispatch = useDispatch() 

	const userDomain = useSelector((state) => state?.selectedDomain?.userDomain) || '';

	const changePassword = async (currentPassword, newPassword) => {
		setShowSpinner(true)
		let typeOfApp = appType;
		let changePasswordObj = {};
		if (typeOfApp) {
			changePasswordObj = {
				oldPassword: currentPassword,
				newPassword: newPassword,
				appType: typeOfApp,
			};
		} else {
			changePasswordObj = {
				oldPassword: currentPassword,
				newPassword: newPassword,
				appType: 'onship'
			};
		}


		try {
			const response = await webSocketApiService.ChangePassword(changePasswordObj);
			if (response.success) {
				showToast( "success", "Password has been changed" );
				dispatch(addAppNotification("Password has been changed", BANNER_TYPE_INFO));
				onClose()
			} else {
				if (response && response.message === "Incorrect username or password.") {
					setError("Current password is incorrect.");
				} else {
					setError(response.message || "Change password failed. Please try again.");
				}
			}
		} catch (error) {
			console.log("error on change password");
			if (error && error.message === "Incorrect username or password.") {
				setError("Current password is incorrect.");
			} else {
				setError(error.message || "Change password failed. Please try again.");
			}
		}finally{
			setShowSpinner(false)
		}
	};


	const clearListCookies = () => {
		const cookies = document.cookie.split(";");
		for (let i = 0; i < cookies.length; i++) {
			const spcook = cookies[i].split("=");
			deleteCookie(spcook[0]);
		}

		function deleteCookie(cookiename) {
			const d = new Date();
			d.setDate(d.getDate() - 1);
			const expires = ";expires=" + d;
			const name = cookiename;
			const value = "";
			document.cookie = name + "=" + value + expires + "; path=/acc/html";
		}
	};

	const modifyCurrentPassword = (e) => {
		setCurrentPassword(e.target.value);
		setError(null);
	};

	const modifyPassword = (e) => {
		setPassword(e.target.value);
		passwordChecking(e.target.value);
		if (e.target.value === currentPassword) {
			setError("New password cannot be the same as the current password.");
		} else {
			setError(null);
		}
	};

	const modifyPassword2 = (e) => setPassword2(e.target.value);

	const onFormSubmit = (e) => {
		e.preventDefault();
		setError(null);
		changePassword(currentPassword, password)

	};

	const passwordValidation = (string) => {
		let counter = 0;
		if (string.length >= 8) {
			if (/[a-z]/.test(string)) counter++;
			if (/[A-Z]/.test(string)) counter++;
			if (/[0-9]/.test(string)) counter++;
			if (/[\^$*.[\]{}()?"!'@#%&\\/,><:;|_~`]/.test(string)) counter++;
		}
		return counter === 4;
	};

	const passwordChecking = (string) => {
		const newArr = [...passwordCriteria];
		if (string.length >= 8) {
			newArr[4].isDone = true;
		} else {
			newArr[4].isDone = false;
		}
		newArr[1].isDone = /[a-z]/.test(string);
		newArr[0].isDone = /[A-Z]/.test(string);
		newArr[3].isDone = /[0-9]/.test(string);
		newArr[2].isDone = /[\^$*.[\]{}()?"!'@#%&\\/,><:;|_~`]/.test(string);
		setPasswordCriteria(newArr);
	};

	const passwordConfirm = () => {
		return password === password2
	}

	const disableChangePasswordButton = () => {
		const passwordResult = passwordValidation(password);
		const passwordConfirmResult = password === password2;

		return !error && passwordResult && passwordConfirmResult;
	};
	return (
		<>
			{
				error && (
					<CustomErrorTypography>
						{error}
					</CustomErrorTypography>
				)

			}
			{showToolTip && (
				<CustomToolTip>
					<p style={{ fontSize: "13px" }}>Password must contain:</p>
					<ul style={{ padding: "5px", listStyle: "none", margin: 0 }}>
						{passwordCriteria.map((criterion, index) => (
							<li
								key={index}
								style={{
									display: "flex",
									alignItems: "center",
									gap: "6px",
									color: criterion.isDone ? "green" : "inherit",
									fontSize: "13px",
								}}
							>
								{criterion.isDone ? (
									<span style={{ color: "green",fontSize: "13px", }}>✔</span>
								) : (
									<span style={{ width: "14px",fontSize: "13px", }}>•</span>
								)}

								{criterion.text}
							</li>
						))}
					</ul>
				</CustomToolTip>

			)} 
			<PasswordFieldForModals
				value={currentPassword}
				label="Current Password"
				onChangeFn={modifyCurrentPassword}
				placeholder={"Please enter your current password"}
			/>
			<PasswordFieldForModals
				value={password}
				label="New password"
				onChangeFn={modifyPassword}
				placeholder={"Please enter your new password"}
				customMarginTop={"30px"}
				onFocusFn={() => setShowToolTip(true)}
				onBlurFn={() => setShowToolTip(false)}
			/>
			{passwordCriteria.every(criteria => criteria.isDone) && (
					<>
					<Tooltip>
						<MatchStatusTypography>Perfect!</MatchStatusTypography>
					</Tooltip>
				</>
			)}
			<PasswordFieldForModals
				value={password2}
				type={"password"}
				label="Re-Enter New Password"
				onChangeFn={modifyPassword2}
				placeholder={"Please enter your re-enter new password"}
				customMarginTop={"30px"}
			/>
			{password2 && password2.length > 7 && passwordConfirm() && (
				<>
					<Tooltip>
						<MatchStatusTypography>Match!</MatchStatusTypography>
					</Tooltip>
				</>
			)}

			<ModalConfirmButton
				customWidth={400}
				customBgColor={BUTTON_COLOR_NEW_UI}
				// label="Submit"
				label={
					showSpinner ? (
						<CircularProgress size='2vh' thickness={5} color='inherit' />
					) : (
						"Submit"
					)
				}
				customMarginTop="30px"
				custompadding={"10px 0px"}
				onClickFn={onFormSubmit}
				disabled={!disableChangePasswordButton() || showSpinner}
			/>
		</>
	);
};

export default ChangePasswordModal;
